import { Component, Input, OnInit } from '@angular/core';
import { cpf } from 'cpf-cnpj-validator';
import { Credencial } from 'src/models/credencial.model';
import { WebSimulacao } from 'src/models/webSimulacao.model';
import { LoginService } from 'src/services/login.service';
import { WebSimulacaoService } from 'src/services/webSimulacao.service';
import validator from 'validator'
import { interval, Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {

  credencial: Credencial = new Credencial();
  simulacao: WebSimulacao = new WebSimulacao();

  values = '';


  nome: string = '';

  interval: any
  timeOut: any = interval(3000)
  rentabilidade: number = 6;
  idade: number;
  anos: number = 3;
  tab: number = 0;
  tempoRecebimento: number = 5;
  dataNascimento: string;
  dataNascimentoDate: Date;
  cpf: string = '';
  cpfValid: boolean = false;
  email: string = '';
  emailValid: boolean = false;

  checked1: number = 0;
  checked2: number = 0;
  checked3: number = 0;
  checked4: number = 0;
  valorSimulacao: number = 0;
  ctbSimulacao: number = 0;
  valorParcelado: number = 0;
  idSimulacao: number = 0;

  ok3: boolean = false;

  pergunta4_nao: number = null;
  pergunta4_sim: number = null;

  pergunta5_sim: number = null;
  pergunta5_nao: boolean = false;

  pergunta7_sim: number = null;
  pergunta7_nao: boolean = false;

  finalContent: boolean = false;


  constructor(
    private readonly loginService: LoginService,
    private readonly webSimulacaoService: WebSimulacaoService
  ) { }


  ngOnInit() {
    this.credencial.login = "TRUSTWEB";
    this.credencial.senha = "TVARLBUTIB";
    this.loginService.autenticar(this.credencial).subscribe((obj) => {
      console.log("token:", obj.token)
      localStorage.setItem("token", obj.token);
    });
  }

  iAnual(i) {
    return Math.pow((1 + (i / 100)), 1 / 12) - 1;
  }

  valorFuturo(vP, dM, i, n) {
    return vP * Math.pow((1 + i), n) + dM * (((Math.pow((1 + i), n)) - 1) / i);
  }

  valorPresente(vP, dM, i, n) {
    return vP / (((Math.pow((1 + i), n)) - 1) / i) + dM / (((Math.pow((1 + i), n)) - 1) / i);
  }

  calcularIdade() {

    if (this.dataNascimento.length === 8) {
      const day = this.dataNascimento.slice(0, 2)
      const month = this.dataNascimento.slice(2, 4)
      const year = this.dataNascimento.slice(4, 8)
      this.dataNascimentoDate = new Date(`${year}-${month}-${day}`)
    } else {
      this.dataNascimentoDate = null
    }


    const timeSpan = new Date().getTime() - this.dataNascimentoDate.getTime()
    const anos = 1000 * 60 * 60 * 24 * 365
    this.idade = Math.floor(timeSpan / anos)

  }

  checarCPF() {
    this.cpfValid = cpf.isValid(this.cpf);
  }

  checarEmail() {
    this.emailValid = validator.isEmail(this.email);
  }


  isDataNascimentoValid() {
    if (!this.dataNascimentoDate) return false;
    return validator.isDate(this.dataNascimentoDate.toISOString().slice(0, 10))
  }

  handleCheckClick(pergunta: number) {
    switch (pergunta) {
      case 5:
        this.pergunta5_nao = true;
        break;

      case 7:
        this.pergunta7_nao = true;
        break;
    }
  }

  formatMoney(n: number) {
    return n.toLocaleString('pt-br', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }).replace("R$", "");
  }

  handleSimular() {
    switch (this.checked2) {
      case 1:
        this.pergunta5_sim = this.pergunta5_sim ? this.pergunta5_sim : 0;
        this.valorSimulacao = this.valorFuturo(this.pergunta5_sim, this.pergunta4_nao, this.iAnual(this.rentabilidade), this.anos * 12);
        this.valorParcelado = this.valorSimulacao / (this.tempoRecebimento * 13);
        break;
      case 2:
        this.valorParcelado = this.pergunta4_sim / (this.tempoRecebimento * 13);
        this.valorSimulacao = this.pergunta4_sim;
        this.ctbSimulacao = this.valorPresente(this.pergunta5_sim, this.valorSimulacao, this.iAnual(this.rentabilidade), this.anos * 12);
        break;
    }

    if (this.interval) {
      this.interval.unsubscribe()
    }

    this.timeOut = interval(3000)
    this.interval = this.timeOut.subscribe((n) => {
      this.salvarSimulacao()
    })


  }

  handleInput(event: any, pergunta: number) {

    switch (pergunta) {
      case 1:
        this.nome = event.target.value;
        break;

      case 2:
        this.idade = event.target.value;
        break;

      case 3:
        this.pergunta4_sim = event.target.value;
        break;

      case 4:
        this.pergunta4_nao = event.target.value;
        break;

      case 5:
        this.pergunta5_sim = event.target.value;
        this.pergunta5_nao = false;
        break;

      case 7:
        this.pergunta7_sim = event.target.value;
        this.pergunta7_nao = false;
        break;

    }
  }

  next() {
    this.tab++;
    if (this.tab > 6) {
      document.querySelector("body").style.height = "auto";
      document.querySelector("body").style.overflowY = "scroll";
      this.handleSimular()
    }
  }

  back() {
    if (this.tab) this.tab--;
  }

  check1(value) {
    this.checked1 = value;
    this.ok3 = true;
  }

  check2(value) {
    this.checked2 = value;
    this.ok3 = true;
  }

  check3(value) {
    this.checked3 = value;
    this.ok3 = true;
  }

  check4(value) {
    this.checked4 = value;
    this.ok3 = true;
  }

  ProgressBar(value) {
    let bar = document.getElementById("myBar");
    bar.style.width = value + "%";

    if (value >= 20) {
      document.getElementById("circle1").style.backgroundColor = "#00497C";
    }

    if (value >= 50) {
      document.getElementById("circle2").style.backgroundColor = "#00497C";
    }

    if (value >= 90) {
      document.getElementById("circle3").style.backgroundColor = "#00497C";
    }
  }

  salvarSimulacao() {

    this.simulacao.email = this.email;
    this.simulacao.nome = this.nome;
    this.simulacao.cpf = this.cpf;
    this.simulacao.valorAporte = this.pergunta5_sim ? this.pergunta5_sim : 0
    this.simulacao.anosCtb = this.anos;
    this.simulacao.anosRec = this.tempoRecebimento;
    this.simulacao.rentabilidade = this.rentabilidade;
    this.simulacao.valorSimulacao = this.valorSimulacao;
    this.simulacao.valorCtb = this.checked2 == 2 ? this.ctbSimulacao : this.pergunta4_nao
    this.simulacao.tipoSimulacao = this.checked2;
    this.simulacao.dtNascimento = this.dataNascimentoDate;
    this.simulacao.dtSimulacao = new Date()
    this.webSimulacaoService.salvar(this.simulacao).subscribe(obj => { this.idSimulacao = obj.idSimulacao }, error => console.log(error))
    this.interval.unsubscribe()

  }

  goToAdesao() {
    window.open(`https://familia.previndus.com.br/adesao/#/ar/session/adesao?idSimulacao=${this.idSimulacao}`, "_blank");
  }

  novaSimulacao() {
    //this.nome = '';

    this.rentabilidade = 6;
    //this.dataNascimento = null;
    this.email = '';
    this.cpf = '';
    //this.cpfValid = false;
    //this.emailValid = false;
    //this.idade = null;
    this.anos = 3;
    this.tab = 2;
    this.tempoRecebimento = 5;

    this.checked1 = 0;
    this.checked2 = 0;
    this.checked3 = 0;
    this.checked4 = 0;
    this.valorSimulacao = 0;
    this.ctbSimulacao = 0;
    this.valorParcelado = 0;

    this.ok3 = false;

    this.pergunta4_nao = null;
    this.pergunta4_sim = null;

    this.pergunta5_sim = null;
    this.pergunta5_nao = false;

    this.pergunta7_sim = null;
    this.pergunta7_nao = false;

    this.finalContent = false;
    window.scroll(0, 0);
  }


}